(function () {
  const roots = document.querySelectorAll('[data-withdrawal-root]');
  if (!roots.length) {
    return;
  }

  const fallbackLabels = {
    fieldRequired: 'Fyll i fältet.',
    emailInvalid: 'Ange en giltig e-postadress.',
    lookupError: 'Det gick inte att verifiera ordern just nu. Kontrollera uppgifterna och försök igen.',
    returnWindowExpiredTitle: 'Returfristen har passerat',
    returnWindowExpiredMessage:
      'Ordern \u00e4r \u00e4ldre \u00e4n 20 dagar och kan d\u00e4rf\u00f6r inte registreras som retur i formul\u00e4ret. Kontakta oss om du beh\u00f6ver hj\u00e4lp med en reklamation eller annan fr\u00e5ga.',
    submitError: 'Det gick inte att registrera returen just nu.',
    missingLookup: 'Sök upp ordern igen innan du skickar returen.',
    selectedItemsRequired: 'Välj minst en produkt att returnera.',
    noLineItems: 'Ordern saknar produkter som kan visas här.',
    quantity: 'Antal',
    orderedQuantity: 'Beställt antal',
    orderPrefix: 'Order',
    successDefaultMessage: 'Vi har tagit emot din returregistrering och skickat en kvittens via e-post.',
  };

  function getLabels(root) {
    const labelsNode = root.querySelector('[data-withdrawal-labels]');
    if (!labelsNode) {
      return fallbackLabels;
    }

    try {
      return {
        ...fallbackLabels,
        ...JSON.parse(labelsNode.textContent || '{}'),
      };
    } catch (error) {
      return fallbackLabels;
    }
  }

  function escapeHtml(value) {
    return String(value ?? '').replace(/[&<>"']/g, (char) => {
      const entities = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      };
      return entities[char];
    });
  }

  function setStatus(root, message, kind) {
    const status = root.querySelector('[data-withdrawal-status]');
    if (!status) {
      return;
    }

    status.textContent = message || '';
    status.dataset.kind = kind || 'info';
    status.hidden = !message;
  }

  function setFallback(root, visible) {
    const fallback = root.querySelector('[data-withdrawal-fallback]');
    if (fallback) {
      fallback.hidden = !visible;
    }
  }

  function setIneligibleBlock(root, visible, eligibility, labels) {
    const ineligible = root.querySelector('[data-withdrawal-ineligible]');
    if (!ineligible) {
      return;
    }

    const title = ineligible.querySelector('[data-withdrawal-ineligible-title]');
    const message = ineligible.querySelector('[data-withdrawal-ineligible-message]');

    if (title) {
      title.textContent = eligibility?.title || labels.returnWindowExpiredTitle;
    }

    if (message) {
      message.textContent = eligibility?.message || labels.returnWindowExpiredMessage;
    }

    ineligible.hidden = !visible;
  }

  function setButtonBusy(button, busy) {
    if (!button) {
      return;
    }

    const label = button.querySelector('[data-button-label]');
    const loading = button.querySelector('[data-button-loading]');
    button.disabled = busy;

    if (label && loading) {
      label.hidden = busy;
      loading.hidden = !busy;
    }
  }

  async function readJson(response, fallbackMessage) {
    const data = await response.json().catch(() => null);
    if (!response.ok) {
      throw new Error(data?.message || data?.error || fallbackMessage);
    }
    return data;
  }

  function validateLookupForm(form, labels) {
    const email = form.elements.customerEmail;
    const orderName = form.elements.orderName;

    orderName.setCustomValidity('');
    email.setCustomValidity('');

    if (!orderName.value.trim()) {
      orderName.setCustomValidity(labels.fieldRequired);
    }

    if (!email.value.trim()) {
      email.setCustomValidity(labels.fieldRequired);
    } else if (!email.validity.valid) {
      email.setCustomValidity(labels.emailInvalid);
    }

    return form.reportValidity();
  }

  function formatMoney(amount, currencyCode, locale) {
    if (!amount || !currencyCode) {
      return '';
    }

    const numericAmount = Number(amount);
    if (!Number.isFinite(numericAmount)) {
      return '';
    }

    try {
      return new Intl.NumberFormat(locale || 'sv-SE', {
        style: 'currency',
        currency: currencyCode,
      }).format(numericAmount);
    } catch (error) {
      return `${amount} ${currencyCode}`;
    }
  }

  function safePositiveInteger(value) {
    const parsed = Number.parseInt(value, 10);
    if (!Number.isFinite(parsed) || parsed < 0) {
      return 0;
    }
    return parsed;
  }

  function renderOrder(root, order, labels) {
    const verifiedOrder = root.querySelector('[data-withdrawal-verified-order]');
    const lineItems = root.querySelector('[data-withdrawal-line-items]');
    const locale = root.dataset.locale || document.documentElement.lang || 'sv-SE';
    const orderName = order?.orderName || root.querySelector('[data-withdrawal-order-name]')?.value || '';
    const customer = order?.customerName || order?.customerEmail || '';
    const total = formatMoney(order?.totalAmount, order?.currencyCode, locale);
    const items = Array.isArray(order?.lineItems) ? order.lineItems : [];

    if (verifiedOrder) {
      verifiedOrder.innerHTML = `
        <strong>${escapeHtml(labels.orderPrefix)} ${escapeHtml(orderName)}</strong>
        ${customer ? `<span>${escapeHtml(customer)}</span>` : ''}
        ${total ? `<span>${escapeHtml(total)}</span>` : ''}
      `;
    }

    if (!lineItems) {
      return;
    }

    if (!items.length) {
      lineItems.innerHTML = `<p class="withdrawal-form__empty-lines">${escapeHtml(labels.noLineItems)}</p>`;
      return;
    }

    lineItems.innerHTML = items
      .map((lineItem) => {
        const maxQuantity = safePositiveInteger(lineItem.quantity);
        const image = lineItem.imageUrl
          ? `<img alt="" src="${escapeHtml(lineItem.imageUrl)}" loading="lazy">`
          : '<span class="withdrawal-form__line-thumb" aria-hidden="true"></span>';
        const meta = [lineItem.variantTitle, lineItem.sku, formatMoney(lineItem.totalAmount, lineItem.currencyCode, locale)]
          .filter(Boolean)
          .join(' - ');

        return `
          <label class="withdrawal-form__line-item">
            ${image}
            <span class="withdrawal-form__line-copy">
              <span class="withdrawal-form__line-title">${escapeHtml(lineItem.title || '')}</span>
              <span class="withdrawal-form__line-meta">${escapeHtml(meta || `${labels.orderedQuantity}: ${maxQuantity}`)}</span>
            </span>
            <span class="withdrawal-form__quantity">
              <span>${escapeHtml(labels.quantity)}</span>
              <input
                data-withdrawal-line-quantity
                data-line-item-id="${escapeHtml(lineItem.lineItemId || '')}"
                min="0"
                max="${maxQuantity}"
                step="1"
                type="number"
                value="${maxQuantity}"
              >
            </span>
          </label>
        `;
      })
      .join('');
  }

  function currentScope(root) {
    return root.querySelector('[data-withdrawal-scope]:checked')?.value || 'full_order';
  }

  function updateLineItemVisibility(root) {
    const lineItems = root.querySelector('[data-withdrawal-line-items]');
    if (lineItems) {
      lineItems.hidden = currentScope(root) !== 'selected_items';
    }
  }

  function selectedLineItems(root) {
    return Array.from(root.querySelectorAll('[data-withdrawal-line-quantity]'))
      .map((input) => ({
        lineItemId: input.dataset.lineItemId,
        quantity: safePositiveInteger(input.value),
      }))
      .filter((selection) => selection.lineItemId && selection.quantity > 0);
  }

  function getSafeUrl(value) {
    if (!value) {
      return null;
    }

    try {
      const url = new URL(value, window.location.origin);
      if (url.protocol === 'https:' || url.origin === window.location.origin) {
        return url.href;
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  function showSuccess(root, data, labels) {
    const returnForm = root.querySelector('[data-withdrawal-return-form]');
    const success = root.querySelector('[data-withdrawal-success]');
    if (!returnForm || !success) {
      return;
    }

    returnForm.hidden = true;
    success.hidden = false;

    const message = success.querySelector('[data-success-message]');
    if (message) {
      message.textContent = data?.message || labels.successDefaultMessage;
    }

    const returnId = data?.returnId || data?.noticeId || '';
    const returnIdRow = success.querySelector('[data-success-return-id-row]');
    const returnIdNode = success.querySelector('[data-success-return-id]');
    if (returnIdRow && returnIdNode) {
      returnIdNode.textContent = returnId;
      returnIdRow.hidden = !returnId;
    }

    const returnLink = success.querySelector('[data-success-return-link]');
    const returnUrl = getSafeUrl(data?.publicReturnUrl || data?.publicTicketUrl);
    if (returnLink && returnUrl) {
      returnLink.href = returnUrl;
      returnLink.hidden = false;
    }
  }

  function isOutsideReturnWindow(data) {
    const eligibility = data?.returnEligibility;
    return eligibility?.eligible === false && eligibility?.reason === 'outside_return_window';
  }

  roots.forEach((root) => {
    const labels = getLabels(root);
    const lookupForm = root.querySelector('[data-withdrawal-lookup-form]');
    const returnForm = root.querySelector('[data-withdrawal-return-form]');
    const success = root.querySelector('[data-withdrawal-success]');
    const lookupButton = root.querySelector('[data-withdrawal-lookup-button]');
    const submitButton = root.querySelector('[data-withdrawal-submit-button]');
    const resetButtons = root.querySelectorAll('[data-withdrawal-reset], [data-withdrawal-ineligible-reset]');
    const orderInput = root.querySelector('[data-withdrawal-order-name]');
    const params = new URLSearchParams(window.location.search);

    if (!lookupForm || !returnForm) {
      return;
    }

    if (orderInput && params.has('order')) {
      orderInput.value = params.get('order') || '';
    }
    if (params.get('source') === 'account_order') {
      root.dataset.sourceContext = 'account_order';
    }

    let lookupToken = null;
    let verifiedOrder = null;
    let lookingUp = false;
    let submitting = false;

    root.querySelectorAll('[data-withdrawal-scope]').forEach((input) => {
      input.addEventListener('change', () => updateLineItemVisibility(root));
    });

    function resetFlow() {
      lookupToken = null;
      verifiedOrder = null;
      lookupForm.hidden = false;
      returnForm.hidden = true;
      setIneligibleBlock(root, false, null, labels);
      if (success) {
        success.hidden = true;
      }
      setStatus(root, '', 'info');
      setFallback(root, false);
    }

    resetButtons.forEach((button) => {
      button.addEventListener('click', resetFlow);
    });

    lookupForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (lookingUp || !validateLookupForm(lookupForm, labels)) {
        return;
      }

      setStatus(root, '', 'info');
      setFallback(root, false);
      setIneligibleBlock(root, false, null, labels);
      setButtonBusy(lookupButton, true);
      lookingUp = true;

      const orderName = lookupForm.elements.orderName.value.trim();
      const customerEmail = lookupForm.elements.customerEmail.value.trim();

      try {
        const response = await fetch(root.dataset.orderLookupEndpoint || '/apps/servicedrive/returns/order-lookup', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            orderName,
            customerEmail,
            locale: root.dataset.locale || document.documentElement.lang || 'sv-SE',
            sourceContext: root.dataset.sourceContext || 'return_page',
          }),
        });
        const data = await readJson(response, labels.lookupError);

        if (isOutsideReturnWindow(data)) {
          lookupToken = null;
          verifiedOrder = null;
          lookupForm.hidden = true;
          returnForm.hidden = true;
          setIneligibleBlock(root, true, data.returnEligibility, labels);
          return;
        }

        lookupToken = data.lookupToken;
        verifiedOrder = data.order;
        renderOrder(root, verifiedOrder, labels);
        lookupForm.hidden = true;
        returnForm.hidden = false;
        updateLineItemVisibility(root);
      } catch (error) {
        setStatus(root, error instanceof Error ? error.message : labels.lookupError, 'error');
        setFallback(root, true);
      } finally {
        lookingUp = false;
        setButtonBusy(lookupButton, false);
      }
    });

    returnForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitting || !returnForm.reportValidity()) {
        return;
      }

      setStatus(root, '', 'info');
      setFallback(root, false);

      if (!lookupToken || !verifiedOrder) {
        setStatus(root, labels.missingLookup, 'error');
        return;
      }

      const scope = currentScope(root);
      const lineSelections = selectedLineItems(root);

      if (scope === 'selected_items' && !lineSelections.length) {
        setStatus(root, labels.selectedItemsRequired, 'error');
        return;
      }

      setButtonBusy(submitButton, true);
      submitting = true;

      try {
        const response = await fetch(root.dataset.returnEndpoint || '/apps/servicedrive/returns', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            lookupToken,
            scope,
            selectedLineItems: scope === 'selected_items' ? lineSelections : undefined,
            customerMessage: returnForm.elements.customerMessage.value.trim() || undefined,
            receiptChannel: 'email',
            explicitConfirmation: true,
            locale: root.dataset.locale || document.documentElement.lang || 'sv-SE',
            sourceContext: root.dataset.sourceContext || 'return_page',
            returnUrl: window.location.href,
          }),
        });
        const data = await readJson(response, labels.submitError);

        showSuccess(root, data || {}, labels);
      } catch (error) {
        setStatus(root, error instanceof Error ? error.message : labels.submitError, 'error');
        setFallback(root, true);
      } finally {
        submitting = false;
        setButtonBusy(submitButton, false);
      }
    });
  });
})();
